//
//
//
//
//
//
//
//
//
//
//
//
//

import fileReplace from "@/pccomponents/FileReplace";
import uploadFile from "@/pcpage/contract/file/uploadFile";
import * as axios from "@/store/http";
export default {
    extends: uploadFile,
    name: "showFileList",
    components: {
        fileReplace
    },
    props: {
        showFileLists: {//展示列表
            type:Array,
            default: () => []
        },
        keyval: {
            type: String,
            default: 0
        },
        deleteItem: {//删除编辑项
            type: String,
            default: ""
        },
        replaceItem: {//替换编辑项
            type: String,
            default: ""
        },
        editItem: {
            type: String,
            default: ""
        },
        fileForm:{
            type: Object,
            default: () => ({})
        },
        delBackFunc:{//删除时回调函数
           type:Function,
            default:null
        },
        uuid:{
            type: String,
            default: ""
        },
        //是否兼容不用登陆访问
        nosession:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            maxSize:"",
            getdoctype:"file/getDocuTypeInfo"
        };
    },
    methods: {
        uploadSuccessBack(fileId, fileName) {
            //替换成功后的回调函数
            if (this.showFileLists.length > 0) {
                for (let i = 0; i < this.showFileLists.length; i++) {
                    if (this.showFileLists[i].fileid == fileId) {
                        this.$set(this.showFileLists[i], "filename", fileName);
                    }
                }
            }
        },
        async initFileConfig(){//初始化文件配置
            let url = this.getdoctype;
            if(this.fileForm.docutypeid==""||this.fileForm.docutypeid==undefined){
                return ;
            }
            let params = {
            record: {
                btype: this.fileForm.btype,
                docutypeid:this.fileForm.docutypeid,
            }
            };
           await axios.post(url, params).then(res => {
            if(res.data.code=="1"){
                let docuinfo=res.data.data.record.docuinfo;
                if(docuinfo!=undefined){
                if(this.isNotNullOrEmpty(docuinfo.maxsize)){
                    this.maxSize=docuinfo.maxsize+"";
                }
                }
            }
            });
        },
    },
    computed: {
        readonly: function () {
            if (this.editItem.indexOf(";" + this.deleteItem + ";") === -1) {
                //需要返回,true,设为只读
                return true;
            } else {
                return false;
            }
        }
    },
    created() {
        if(this.nosession == true){
            this.getdoctype = "api/api/portalFile/getDocuTypeInfo";
            this.downloadUrl = "api/api/portalFile/download";
            this.getFileListUrl = "api/api/portalFile/getFileInfos";
            this.deletfileUrl ="api/api/portalFile/delefilebyId";
        }
        this.initFileConfig();
    }
};



// WEBPACK FOOTER //
// ./src/pcpage/contract/file/ShowFileList.vue